export const USERDATA_SHOW_RESET = 'USERDATA_SHOW_RESET'
export const USERDATA_SHOW_SET_ERROR = 'USERDATA_SHOW_SET_ERROR'
export const USERDATA_SHOW_SET_RETRIEVED = 'USERDATA_SHOW_SET_RETRIEVED'
export const USERDATA_SHOW_TOGGLE_LOADING = 'USERDATA_SHOW_TOGGLE_LOADING'
